import { render, staticRenderFns } from "./ExpenseRecovery.vue?vue&type=template&id=2f9b2eb6"
import script from "./ExpenseRecovery.vue?vue&type=script&lang=js"
export * from "./ExpenseRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports